








import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobWorkerOfferDto from '@/models/JobWorkerOffers/JobWorkerOfferDto';

@Component({
  name: 'JobWorkerOfferContactConfirmationStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	offer: JobWorkerOfferDto;

	get pendingConfirmation() {
		return (!this.offer.contactConfirmedById && !this.offer.contactDeclinedById);
	}

	get confirmed() {
		if (this.offer.contactConfirmedById) {
			return true;
		}
		return false
	}

	get declined() {
		if (this.offer.contactDeclinedById) {
			return true;
		}
		return false
	}
}
